<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div style="min-width: 200px">
        <v-tabs v-model="tab" grow class="tab-btn-style">
          <v-tab class="c-tab">Student Attendance Report</v-tab>
          <v-tab class="c-tab">Teacher Attendance Report</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <student-report @created="handleCreate"></student-report>
        </v-tab-item>
        <v-tab-item>
          <teacher-report v-bind:counter="rerender"></teacher-report>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../../components/BreadCrumbs";
import StudentReport from "../../../../components/reports/Student/Student";
import TeacherReport from "../../../../components/reports/Teacher/Teacher";

export default {
  name: "AttendanceReportIndex",
  components: {
    StudentReport,
    TeacherReport,
    BreadCrumbs,
  },
  methods: {
    handleCreate() {
      this.rerender = this.rerender + 1;
    },
  },
  data() {
    return {
      tab: null,
      rerender: 1,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
  created() {
    if (typeof this.$route.params != "undefined" && this.$route.params != null) {
      this.tab = this.$route.params.tab;
    }
  },
};
</script>

<style lang="scss" scoped>
.nmt-1 {
  margin-top: -12px;
}

.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;

  &.v-tab--active {
    background: white;
  }
}
</style>
